import { render, staticRenderFns } from "./ProjectOtherNotice.vue?vue&type=template&id=08920610&scoped=true"
import script from "./ProjectOtherNotice.vue?vue&type=script&lang=js"
export * from "./ProjectOtherNotice.vue?vue&type=script&lang=js"
import style0 from "./ProjectOtherNotice.vue?vue&type=style&index=0&id=08920610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08920610",
  null
  
)

export default component.exports